import { SettingsReducer } from './types';

export const reducer: SettingsReducer = (state, action) => {
  if (action.type === 'GAME_SEARCH_ACTIVE') {
    return {
      ...state,
      isGameSearchActive: action.payload
    };
  }
  if (action.type === 'TRIGGER_BONUS_MODAL') {
    return {
      ...state,
      triggerBonusModal: !state.triggerBonusModal
    };
  }
  return state;
};

export function inferLiteralFromString<T extends string>(arg: T): T {
  return arg;
}
